<template>
  <section class="secNav">
    <div class="navbox">
      <div class="nav">
        <div class="logo-i18n">
          <div class="logo">{{ $t('nav.xwallet') /* XWallet */}}</div>
          <!-- <ul class="i18n-lang-list">
            <li v-for="list in langList" :key="list.iso" :class="{active: list.iso === lang}" @click="changeLang(list.iso)">{{list.name}}</li>
          </ul> -->
          <div class="i18n-lang-label">
            <div class="lang-con" @click="showLangList">{{currentLang}}<span class="ico_arrow" :class="{'change': langListDialog}"></span></div>
            <div class="lang-list" ref="lang-list">
              <label v-for="list in langList" :key="list.iso">
                <input type="radio" name="lang" :value="list.iso" v-model="$i18n.locale" hidden>
                <span>{{list.name}}</span>
              </label>
            </div>
            <div class="mask" v-show="langListDialog" @click="hidLangList"></div>
          </div>
        </div>
        <ul class="links">
          <li class="link" :class="[{active: routeName === 'Overview'}]"><router-link class="router" :to="'/'">{{ $t('nav.overview') /* Overview */}}</router-link></li>
          <!-- <li class="link" :class="[{active: routeName === 'HowToUse'}]"><router-link class="router" :to="'/howtouse'">{{ $t('nav.howToUse') /* How to use */}}</router-link></li> -->
          <!-- <li class="link" :class="[{active: routeName === 'UserGuide'}]"><router-link class="router" :to="'/userguide'">{{ $t('nav.userGuide') /* User Guide */}}</router-link></li> -->
          <!-- <li class="link" :class="[{active: routeName === 'MerchantOperation'}]"><router-link class="router" :to="'/merchantoperation'">{{ $t('nav.merchantGuide') /* Merchant Guide */}}</router-link></li> -->
          <li class="link" :class="[{active: routeName === 'FAQ'}]"><a class="router" href="https://pundix.zendesk.com/hc/en-us/categories/360001370531-XWallet-FAQ" target="_blank">{{ $t('nav.faq') /* FAQ */}}</a></li>
          <li class="link"><a class="router" href="https://drive.google.com/file/d/1rnd6FpPnolMznq7eyvKq6pkyQvOcxWb2/view?usp=sharing" target="_blank">{{ $t('nav.agreement') /* User agreement */}}</a></li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "secNav",
    data () {
      return {
        routeName: '',
        langList: [{
          iso: 'en',
          name: this.$t('lang.en')
        }, {
        //   iso: 'ko',
        //   name: this.$t('lang.ko')
        // }, {
          iso: 'jp',
          name: this.$t('lang.jp')
        }, {
          iso: 'es',
          name: this.$t('lang.es')
        },
        {
          iso: 'pt',
          name: this.$t('lang.pt')
        },
        {
          iso: 'zhHant',
          name: this.$t('lang.zhHant')
        }],
        currentLang: '',
        langListDialog: false
      }
    },
    methods: {
      routerPath () {
        this.routeName = this.$route.name
      },
      changeLang(val) {
        sessionStorage.setItem('lang', val);
        window.location.reload();
      },
      showLangList () {
        this.langListDialog = true
        this.$refs['lang-list'].style.display = 'block'
      },
      hidLangList () {
        this.langListDialog = false
        this.$refs['lang-list'].style.display = 'none'
      }
    },
    watch: {
      '$route': 'routerPath',
      '$i18n.locale': 'changeLang',
    },
    mounted () {
      this.routerPath()
      if (sessionStorage.getItem('lang') === null || sessionStorage.getItem('lang') === 'undefined') {
        this.currentLang = this.$t('lang.en')
      } else {
        this.currentLang = this.$t('lang.' + sessionStorage.getItem('lang'))
      }
    }
  }
</script>

<style lang="scss" scoped>
.logo-i18n{
  display: flex;
}
.i18n-lang-label {
  color: #999999;
  display: flex;
  align-items: center;
  margin-left: 32px;
  
  label {
    & + label {
      margin-left: 16px;
    }

    input[type="radio"]:checked + span {
      position: relative;
      color: rgba(255, 255, 255, 1);
    
      &::before {
        background-color: #fff;
      }
    }

    span{
      font-size: 16px;
      cursor: pointer;
      transition: color 0.2s;

      &:hover {
        color: rgba(255, 255, 255, 1);
      }

      &::before {
        content: '';
        width: 5px;
        height: 5px;
        border-radius: 100%;
        background-color: transparent;
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
      }
    }
  }
}
</style>


<style scoped>
  .secNav{
    width: 100%;
    position: absolute;
    top: 87px;
    z-index: 10;
  }
  .navbox{
    height: 38px;
    max-width: 1200px;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 15px;
    margin-left: auto;
    margin-right: auto;
  }
  .nav{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #404040;
  }
  .logo{
    font-size: 24px;
    color: rgba(255,255,255,0.87);
    text-align: left;
    line-height: 32px;
  }
  .links{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .link+.link{
    margin-left: 24px;
  }
  .router{
    font-size: 14px;
    color: #999999;
  }
  .link.active .router{
    color: #FFFFFF;
  }
  .lang-con {
    display: none
  }
  @media screen and (max-width: 1100px){
    .nav {
      display: block;
      padding-bottom: 7px;
    }
    .navbox{
      padding-left: 20px;
      padding-right: 20px;
    }
    .logo{
      font-size: 16px;
      display: block;
      line-height: 18px;
      /* width: 100%; */
    }
    .links {
      display: block;
      margin-top: 20px;
    }
    .link {
      display: inline-block;
      line-height: 16px
    }
    .router{
      font-size: 14px;
      color: #999999;
    }
    .link+.link{
      margin-left: 0px;
      margin-right: 12px;
    }
    .link:not(first-child){
      margin-right: 41px;
    }
  }
  @media screen and (max-width: 768px){
    .secNav{
      top: 50px;
    }
    .lang-con {
      display: block;
      font-size: 14px;
      color: #EFEFEF;
      position: relative;
      padding-right: 20px;
    }
    .lang-con .ico_arrow {
      display: block;
      content: "";
      width: 1px;
      height: 1px;
      border-width:0 5px 5px;
      border-style: solid;
      border-color: transparent transparent #EFEFEF;
      position: absolute;
      right: 0;
      top: 25%;
      transform: rotate(180deg);
      transform-origin: center 4.5px;
    }
    .lang-list {
      display: none;
      text-align: center;
      position: absolute;
      top: 30px;
      right: 0;
      background-color: #242424;
      z-index: 3;
      padding: 10px 0;
      border-radius: 2px 0px 2px 2px
    }
    .lang-list::before {
      content: '';
      display: block;
      border-width:0 5px 5px;
      border-style: solid;
      border-color: transparent transparent #242424;
      position: absolute;
      top: -5px;
      right: 0
    }
    .lang-list label {
      padding: 8px 16px;
      font-size: 14px !important;
      color: #EFEFEF;
    }
    .logo-i18n {
      justify-content: space-between
    }
    .i18n-lang-label {
      position: relative
    }
    .i18n-lang-label label {
      display: block
    }
    .lang-list label + label {
      margin: 0
    }
    .i18n-lang-label label span::before {
      display: none
    }
    .mask {
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 2;
    }
    .lang-con .ico_arrow.change {
      transform: rotate(0deg)
    }
  }
</style>